import styled from 'styled-components';

export const TreeWrapper = styled.div`
  margin: 20px 0 20px 0;
`;
